class Dashboard {
  constructor() {}
  registerWholesaleInit() {
    let is_active = localStorage.getItem("buss_user");
    let form_url = tayst.interfaceBusinessDash;
    form_url = form_url.replace("form_id", is_active);
    let dash_wrapper = document.querySelector(".wholesale-dashboard-wrap");
    if (!cn(is_active)) {
      fetch(form_url, {
      body:'',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'POST'
      }).then(ret => ret.json())
      .then(ret => {
        if (ret.status == "0" && !cn(ret.productDetails)) {
          fetch('/collections/dashboard-wholesale-products?view=wholesale-variant-description', {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            method: 'GET'
          }).then(meta_data => meta_data.json()).then(meta_data => {
            localStorage.setItem("wd_meta_data",JSON.stringify(meta_data));
            this.displaySubscription(ret,meta_data,this);
            this.shopItems(ret,meta_data,this);
            this.orderHistory(ret,meta_data,this);
            this.accountSettings(ret,meta_data);
            this.busidashEvents(this,ret);
            this.sideCartData(ret);
            let self = this;
            // scroll page to the targeted internal link
            let target_block = getUrlVars().target;
            let shop_prod_par = document.querySelector(".wd-tab-items.wd-products-wrap .wd-products-items-wrap");
            let target_prod = shop_prod_par.querySelector(`.wd-products[data-id="${target_block}"]`);
            if(!cn(target_block) && !cn(target_prod)){
              let nav_li_first = document.querySelector(".wd-navigation .wd-menu li:first-child");
              if (nav_li_first) {
                nav_li_first.click();
              }
              setTimeout(() => {
                const target_lock = shop_prod_par.querySelector(`.wd-products[data-id="${target_block}"]`);
                if (target_lock) {
                  const top = target_lock.getBoundingClientRect().top + window.pageYOffset - 20;
                   window.scrollTo({
                    top: top,
                    behavior: "auto"
                  });
                  window.scrollTo({
                    top: top,
                    behavior: "smooth"
                  });
                }
                const pageUrl = new URL(window.location.href);
                pageUrl.searchParams.delete("target");
                window.history.replaceState({}, document.title, pageUrl);
              }, 1);
            } else if(cn(ret.subscriptions)) {
              let nav_li_first = document.querySelector(".wd-navigation .wd-menu li:first-child");
              if (nav_li_first) {
                nav_li_first.click();
              }
            }
            setTimeout(function(){
              self.hideLoader();
              self.showSuccessPopup(self);
            },1000);
          })
        }else {
          localStorage.removeItem("buss_user");
          alert(ret.msg);
          const dashProducts = dash_wrapper.getAttribute("data-login");
          if(!cn(getUrlVars().target)){
            location.href = dashProducts + "?target=" + getUrlVars().target;
          }else{
            location.href = dashProducts;
          }
        }
      });
    } else {
      const dashProducts = dash_wrapper.getAttribute("data-login");
      if(!cn(getUrlVars().target)){
        location.href = dashProducts + "?target=" + getUrlVars().target;
      }else{
        location.href = dashProducts;
      }
    }
  }
  displaySubscription(ret,meta_data,that){
    localStorage.setItem("_act_sucrpn",JSON.stringify(ret));
    if(!cn(ret.subscriptions)){
      let subscr_obj = ret.subscriptions;
      let subscr_wrap = document.querySelector(".wd-current-subscription");
      document.querySelector(".wd-current-subscription-no-subscr").classList.add("hidden");
      subscr_wrap.querySelectorAll(".wd-current-subscription-copy").forEach(function(e,i){
        if(i != 0){
          e.remove();
        }
      });
      let gpo_code = "";
      let gpo_prices = "";
      if(!cn(ret.gpo_code) && !cn(ret.gpo_prices)) {
        gpo_code = ret.gpo_code;
        gpo_prices = ret.gpo_prices;        
      }
      let products_obj = ret.productDetails;
      let busi_form_dtl = ret.FormDetails;
      for(let subscr=0; subscr < subscr_obj.length; subscr++){
        let subscr_clone = subscr_wrap.querySelector(".wd-current-subscription-static .wd-current-subscription-copy").cloneNode(true);
        let subscr_addr_drop = subscr_clone.querySelector(".wd-address-drop");
        let subscr_id_tag = subscr_clone.querySelector(".wd-current-subscription-id");
        let subscr_id_tag_text = subscr_id_tag.getAttribute("data-text");
        let curr_subscr = subscr_obj[subscr];
        let subscr_index = subscr+1;
        let subscr_status = curr_subscr.status;
        subscr_clone.setAttribute("data-subscr",curr_subscr.subscription_id);
        subscr_clone.setAttribute("data-index",subscr_index);
        subscr_clone.classList.add("subscrIndex_"+subscr_index);
        subscr_id_tag.textContent = subscr_id_tag_text+" "+subscr_index+" - "+curr_subscr.subscription_id;
        let curr_subscr_address_id = curr_subscr.address_id;
        if(!cn(ret.addresses)){
          for(let addr=0;addr < ret.addresses.length; addr++){
            let curr_addr = ret.addresses[addr];
            let selected_addr = "select";
            let ship_company_name = "";
            let ship_address_2 = "";
            if(!cn(curr_addr.shipping_name)){
              ship_company_name = curr_addr.shipping_name+" | ";
            }
            if(!cn(curr_addr.shipping_address_2)){
              ship_address_2 = curr_addr.shipping_address_2+", ";
            }
            let curr_addr_addr = curr_addr.shipping_address_1+", "+ship_address_2+curr_addr.shipping_city+", "+curr_addr.shipping_state+" "+curr_addr.shipping_zip;
            if(curr_addr.id == curr_subscr_address_id){
              selected_addr = "selected";
            }
            let drop_option = document.createElement('option');
            drop_option.innerHTML = ship_company_name+curr_addr_addr;
            drop_option.value = curr_addr.id;
            drop_option.setAttribute(selected_addr,selected_addr);
            subscr_addr_drop.appendChild(drop_option);
          }
        }
        let subscr_items = curr_subscr.line_items_sku;
        if(!cn(subscr_items)){
          subscr_items = JSON.parse(subscr_items);
          let subscrItemSize = subscr_items.length;
          let items_weight = 0;
          let items_price = 0;
          subscr_items.forEach(function(i,e){
            let subscr_html = subscr_clone.querySelector('.wd-purchased-items-wrap .wd-purchased-item').cloneNode(true);
            subscr_html.setAttribute("data-vid",i.vid);
            subscr_html.setAttribute("data-pid",i.pid);
            subscr_html.setAttribute("data-index",e);
            let item_found = false;
            Object.entries(products_obj).some(prod => {
              let curr_prod = prod[1];
              if(curr_prod.pid == i.pid){
                for(let prodVar=0; prodVar<curr_prod.variants.length; prodVar++){
                  let curr_var = curr_prod.variants[prodVar];
                  let settle_obj = "";
                  let sale_settle_obj = "";
                  if(!cn(busi_form_dtl.price_settlement)){
                    settle_obj = JSON.parse(busi_form_dtl.price_settlement);
                  }
                  if(!cn(busi_form_dtl.price_settlement_sale)){
                    sale_settle_obj = JSON.parse(busi_form_dtl.price_settlement_sale);
                  }
                  if(curr_var.vid == i.vid){
                    let variant_price = parseFloat(curr_var.price);
                    let default_case_size = 1;
                    if(!cn(settle_obj)){
                      for (let k = 0 ; k < settle_obj.length ; k++){
                        let curr_settle = settle_obj[k];
                        if(curr_settle.vid == curr_var.vid){
                          if(!cn(curr_settle.casesize)){
                            default_case_size = curr_settle.casesize;
                          }
                          variant_price = parseFloat(curr_settle.per_pod_price) * parseFloat(default_case_size);
                          break; 
                        }
                      }
                    }
                    if(!cn(gpo_prices)){
                      let gpo_price = gpo_prices[curr_var.sku.toUpperCase()];
                      if(!cn(gpo_price)){
                        variant_price = parseFloat(gpo_price);
                        let gpo_label_cont = subscr_html.querySelector(".wd-purchased-item-gpo-tag");
                        let gpo_label = gpo_label_cont.getAttribute("data-label");
                        gpo_label_cont.textContent = gpo_label?gpo_code +" "+ gpo_label:gpo_code;
                        gpo_label_cont.classList.remove("hide");
                      }
                    }
                    subscr_html.querySelector(".wd-purchased-item-img").setAttribute("src",curr_var.image);
                    subscr_html.querySelector(".wd-purchased-item-title").textContent = curr_var.vtitle;
                    subscr_html.querySelector(".wd-purchased-item-prop").textContent = curr_prod.title;
                    subscr_html.querySelector(".wd-purchased-item-total").setAttribute("data-price",variant_price);
                    subscr_html.querySelector(".wd-purchased-item-qty").value = i.quantity;
                    let total_var_price = i.quantity * variant_price;
                    items_price = items_price + total_var_price;
                    subscr_html.querySelector(".wd-purchased-item-total").innerHTML = wetheme.formatMoney(total_var_price * 100);
                    item_found = true;
                    items_weight = items_weight + (curr_var.weight * i.quantity);
                    if(subscrItemSize == 1){
                      subscr_html.querySelector(".wd-purchased-item-remove").remove();
                    }
                    subscr_clone.querySelector(".wd-purchased-items-wrap").appendChild(subscr_html);
                    break;
                  }
                }
              }
              if(item_found){
                return item_found;
              }
            });
          });
          that.getShipPrice(items_weight,curr_subscr,subscr_clone,items_price,ret,that);
        }
        let date_picker = subscr_clone.querySelector(".wd-subscr-delivery-date");
        let date_val = that.formatToLocalISO(curr_subscr.next_order_date);
        const today_date = new Date();
        flatpickr(date_picker, {
          defaultDate: date_val,
          minDate: "today",
          altFormat: "Y-m-d",
          allowInvalidPreload:true,
          dateFormat: "m/d/Y",
          onOpen: function(selectedDates, dateStr, instance) {
            if (selectedDates.length && selectedDates[0] < today_date) {
              instance.jumpToDate(today_date);
            }
          }
        });
        let subscr_btn = subscr_clone.querySelector(".wd-subscr-active-pause-btn");
        let delivey_wrap = subscr_clone.querySelector(".wd-delivery-content");
        let purchased_items_wrap = subscr_clone.querySelector(".wd-purchased-items-wrap");
        let address_wrap = subscr_clone.querySelector(".address-dropdown");
        let subscr_delivey_title = subscr_clone.querySelector(".wd-delivery-title");
        subscr_btn.setAttribute("data-status",subscr_status);
        if(subscr_status == "0"){
          subscr_btn.textContent = subscr_btn.getAttribute("data-pause");
          delivey_wrap.classList.remove("disabled");
          purchased_items_wrap.classList.remove("disabled");
          address_wrap.classList.remove("disabled");
          subscr_delivey_title.classList.remove("disabled");
          subscr_delivey_title.textContent = subscr_delivey_title.getAttribute("data-active");
          subscr_clone.querySelector(".wd-products-wrap").classList.remove("hidden");
        }else{
          subscr_btn.textContent = subscr_btn.getAttribute("data-active");
          delivey_wrap.classList.add("disabled");
          purchased_items_wrap.classList.add("disabled");
          address_wrap.classList.add("disabled");
          subscr_delivey_title.classList.add("disabled");
          subscr_delivey_title.textContent = subscr_delivey_title.getAttribute("data-paused");
          subscr_clone.querySelector(".wd-products-wrap").classList.add("hidden");
        }
        this.shopItems(ret,meta_data,that,subscr_clone,curr_subscr);
        if(ret.FormDetails?.status == 2){
          subscr_clone.classList.add("disabled");
          subscr_clone.querySelector(".wd-products-wrap").classList.add("hide");
        }
        subscr_wrap.appendChild(subscr_clone);
      }
      let pause_reasons = ret.reasons;
      if(!cn(pause_reasons)){
        let pause_reason_select = document.querySelector(".wd-pause-subscr-popup .wd-pause-subscr-reasons");
        pause_reason_select.innerHTML = '<option value="">Choose reason for pausing</option>';
        pause_reasons.forEach((e,i) => {
          let pause_option = document.createElement("option");
          pause_option.textContent = e;
          pause_option.value = pause_option.textContent;
          pause_reason_select.appendChild(pause_option);
        });
      }
      setTimeout(function(){
      that.dashContentHeight();
      },100);
    }else{
      document.querySelector(".wd-current-subscription-no-subscr").classList.remove("hidden");
    }
  }
  getShipPrice(items_weight,curr_subscr,subscr_clone,items_price,ret,that){
    let getShip = tayst.getBusinessItemsShip.replace("items_weight", items_weight);
    fetch(getShip).then(r => r.json()).then(retdata => {
      if(retdata.status == 0){
        let delivery_par = subscr_clone.querySelector(".wd-delivery-text-wrap");
        delivery_par.querySelector(".wd-subscr-frequency .wd-subscr-frequency-number").textContent = curr_subscr.order_freq;
        delivery_par.querySelector(".wd-subscr-frequency .wd-subscr-frequency-type").textContent = curr_subscr.order_freq_val;
        let summary_wrap = subscr_clone.querySelector(".wd-subscription-summary");
        summary_wrap.querySelector(".wd-subscription-summary-subtotal").innerHTML = wetheme.formatMoney(items_price * 100);
        summary_wrap.querySelector(".wd-subscription-summary-shipping").innerHTML = wetheme.formatMoney(retdata.ship_cost * 100);
        let items_subtotal = items_price + parseInt(retdata.ship_cost);
        summary_wrap.querySelector(".wd-subscription-summary-total").innerHTML = wetheme.formatMoney(items_subtotal * 100);
        summary_wrap.querySelector(".wd-subscription-summary-pay-method-wrap").classList.remove("hidden");
        if(ret.FormDetails.is_credit_card == 1){
          let saved_cards = !cn(ret.savedCards)?ret.savedCards:"";
          let default_card = !cn(ret.savedCards)?saved_cards[0].last4:"";
          if(!cn(saved_cards)){
            for(let s=0;s<saved_cards.length;s++){
              if(saved_cards[s].is_default == 1){
                default_card = saved_cards[s].last4;
                break;
              }
            }
          }
          if(!cn(default_card)){
            summary_wrap.querySelector(".wd-subscription-summary-pay-method").textContent = "****"+default_card;
          }else{
            summary_wrap.querySelector(".wd-subscription-summary-pay-method-wrap").classList.add("hidden");
          }
        }else{
          summary_wrap.querySelector(".wd-subscription-summary-pay-method").textContent = "Invoice";
        }
      }
    });
  }
  shopItems(ret,meta_data,that,is_addon=false,curr_scrn=false){
    let get_products = ret.productDetails;
    let items_len = Object.values(get_products).length;
    let form_details = ret.FormDetails;
    let settle_obj = "";
    let sale_settle_obj = "";
    let gpo_code = "";
    let gpo_prices = "";
    const nonAddonGpoProducts = [];
    const nonAddonNormalProducts = [];
    const addonGpoProducts = [];
    const addonSubscrProducts = [];
    const addonNormalProducts = [];
    let items_par = document.querySelector('.wd-products-clone');
    let subscr_ids = [];
    if(!cn(ret.gpo_code) && !cn(ret.gpo_prices)) {
      gpo_code = ret.gpo_code;
      gpo_prices = ret.gpo_prices;        
    }
    if(!cn(form_details.price_settlement)){
      settle_obj = JSON.parse(form_details.price_settlement);
    }
    if(!cn(form_details.price_settlement_sale)){
      sale_settle_obj = JSON.parse(form_details.price_settlement_sale);
    }
    if(is_addon && !cn(curr_scrn)){
      let scrn_items = JSON.parse(curr_scrn.line_items);
      for(let s=0;s<scrn_items.length;s++){
        subscr_ids.push(parseInt(scrn_items[s].vid));
      }
    }
    const obj_entries = Object.entries(get_products);
    obj_entries.forEach(function(i, b) {
      let curr_item = i[1];
      let subscr_prod_found = false;
      let is_gpo_product = false;
      if(!cn(curr_item)){
        let item_html = items_par.querySelector('.wd-products').cloneNode(true);
        let case_size = curr_item.case_size;
        let item_vars = curr_item.variants;
        let [head_first, ...head_rest] = curr_item.title.split('-');
        item_html.setAttribute("data-id",curr_item.pid);
        item_html.querySelector(".wd-product-title").textContent = head_first;
        if(!cn(head_rest)){
          item_html.querySelector(".wd-product-title").setAttribute("data-resttitle",head_rest.join("-"));
          item_html.querySelector(".wd-product-castitle").textContent = head_rest.join("-");
        }
        for(let j = 0; j < item_vars.length; j++){
          let gpo_variant = false;
          let curr_variant = item_vars[j];
          if(is_addon && subscr_ids.includes(curr_variant.vid)){
            subscr_prod_found = true;
            continue;
          }
          if(curr_variant.vid == 45364781318424){
            continue;
          }
          let variant_price = parseFloat(curr_variant.price);
          let variant_compare_price = "";
          let default_case_size = 1;
          let default_sale_case_size = 1;
          if(!cn(settle_obj)){
            for (let k = 0 ; k < settle_obj.length ; k++){
              let curr_settle = settle_obj[k];
              if(curr_settle.vid == curr_variant.vid){
                if(!cn(curr_settle.casesize)){
                  default_case_size = curr_settle.casesize;
                }
                variant_price = parseFloat(curr_settle.per_pod_price) * parseFloat(default_case_size);
                break; 
              }
            }
          }
          if(!cn(sale_settle_obj)){
            for (let sale = 0 ; sale < sale_settle_obj.length ; sale++){
              let curr_sale_settle = sale_settle_obj[sale];
              if(curr_sale_settle.vid == curr_variant.vid){
                if(!cn(sale_settle_obj.casesize)){
                  default_sale_case_size = sale_settle_obj.casesize;
                }
                variant_compare_price = parseFloat(curr_sale_settle.per_pod_price) * parseFloat(default_sale_case_size); 
                break;
              }
            }
          }
          if(!cn(gpo_prices)){
            let gpo_price = gpo_prices[curr_variant.sku.toUpperCase()];
            if(!cn(gpo_price)){
              variant_price = parseFloat(gpo_price);
              gpo_variant = true;
              is_gpo_product = true;
            }
          }
          let backorder_text_content = document.querySelector(".pre-order-variants");
          let bText = "";
          let bDesc = "";
          if(!cn(backorder_text_content)){
            let back_items = backorder_text_content.querySelectorAll(".variant-pre-order");
            if(back_items.length > 0){
              for(let b=0;b<back_items.length;b++){
                let bItem = back_items[b];
                let bitemText = bItem.innerHTML;
                if(bItem.getAttribute("data-id") == curr_variant.vid){
                  bText = bitemText.split("___")[0];
                  bDesc = bitemText.split("___")[1];
                  bDesc = "<span class='hide'><span class='variant-pre-order-item-text'>"+bDesc+"</span></span>";
                  break;
                }
              }
            }
          }
          let item_clone = items_par.querySelector(".wd-product-card").cloneNode(true);
          let price_val = item_clone.querySelector(".wd-product-price");
          let price_val_compare = item_clone.querySelector(".wd-product-price-compare");
          let curr_v_title = curr_variant.vtitle == "Default Title" ? head_first : curr_variant.vtitle;
          if (!cn(meta_data[curr_variant.vid])) {
            let item_learn_more = item_clone.querySelector(".wd-product-variant-learn-more-wrap");
            item_learn_more.querySelector(".wd-product-variant-learn-more-img").setAttribute("src", curr_variant.image);
            item_learn_more.querySelector(".wd-product-variant-learn-more-img").setAttribute("alt", curr_variant.vtitle);
            if (curr_variant.vtitle === "Default Title") {
              item_learn_more.querySelector(".wd-product-variant-learn-more-title").innerHTML = curr_v_title;
            } else {
              item_learn_more.querySelector(".wd-product-variant-learn-more-title").innerHTML =
                head_first + "<br/><p class='wd-product-variant-learn-more-subtitle'>" + curr_variant.vtitle + "</p>";
            }

            item_learn_more.querySelector(".wd-product-variant-learn-more-desc").innerHTML = meta_data[curr_variant.vid];
            item_learn_more.querySelector(".wd-product-variant-learn-more-desc").innerHTML =
            item_learn_more.querySelector(".wd-product-variant-learn-more-desc").textContent;

            item_clone.querySelector(".wd-product-variant-learn-more-link").setAttribute("data-href", curr_variant.vid);
            item_learn_more.setAttribute("data-id", curr_variant.vid);
          } else {
            item_clone.querySelector(".wd-product-variant-learn-more-wrap").remove();
            item_clone.querySelector(".wd-product-variant-learn-more-link").remove();
          }
          item_clone.querySelector(".wd-product-image").setAttribute("src",curr_variant.image)
          item_clone.querySelector(".wd-product-image").setAttribute("alt",curr_v_title);
          let item_title_break = curr_item.pid == "9594967851288" ? curr_v_title.replace("-","<br/>") : curr_v_title;
          item_clone.querySelector(".wd-product-variant-name").setAttribute("data-vname",curr_v_title);
          item_clone.querySelector(".wd-product-variant-name").innerHTML = item_title_break;
          price_val.innerHTML = wetheme.formatMoney(variant_price * 100);
          if(!cn(variant_compare_price)){
            price_val_compare.innerHTML = "Sale Price: "+ wetheme.formatMoney(variant_compare_price * 100);
          }else{
            price_val_compare.classList.add("hidden");
          }
          if(!cn(case_size)){
            item_clone.querySelector(".wd-product-case").textContent = "/case";
            let per_unit = variant_price/parseInt(case_size);
            let case_type = "";
            if(!cn(curr_item.case_type)){
              case_type = " /"+curr_item.case_type;
            }
            item_clone.querySelector(".wd-product-unit").innerHTML = wetheme.formatMoney(per_unit.toFixed(2) * 100)+" "+case_type;
          }
          let item_product_btn = item_clone.querySelector(".wd-product-btn");
          item_product_btn.setAttribute("data-vid",curr_variant.vid);
          item_product_btn.setAttribute("data-sku",curr_variant.sku);
          item_product_btn.setAttribute("data-weight",curr_variant.weight);
          item_product_btn.setAttribute("data-case",curr_item.case_size);
          item_product_btn.setAttribute("data-price",variant_price);
          if(!cn(bText)){
            item_clone.querySelector(".wd-product-backorder-text").classList.add("has-backorder")
            item_clone.querySelector(".wd-product-backorder-text").innerHTML = bText+bDesc;
          }
          if(!cn(variant_compare_price)){
            item_product_btn.setAttribute("data-price",variant_compare_price);
          }
          if(gpo_variant){
            let gpo_label_cont = item_clone.querySelector(".wd-product-gpo-tag");
            let gpo_label = gpo_label_cont.getAttribute("data-label");
            gpo_label_cont.textContent = gpo_label?gpo_code +" "+ gpo_label:gpo_code;
            gpo_label_cont.classList.remove("hide");
          }
          item_html.querySelector(".wd-product-variant").appendChild(item_clone);
          if(ret.FormDetails?.status == 2){
            item_product_btn.setAttribute("disabled",true);
            item_clone.querySelector(".wd-qty-wrap").classList.add("hide");
            document.querySelector(".wd-content .wd-customer-error").classList.remove("hidden");
          }
        }
        if(!is_addon){
          if(is_gpo_product){
            nonAddonGpoProducts.push(item_html);
          }else{
            nonAddonNormalProducts.push(item_html);
          }
        }else{
          item_html.classList.add("hidden");
          if(is_gpo_product){
            addonGpoProducts.push(item_html);
          }else if(subscr_prod_found){
            addonSubscrProducts.push(item_html);
          }else{
            addonNormalProducts.push(item_html);
          }
        }
      }
    });
    if(!is_addon){
      const wd_products_items_wrap = document.querySelector(".wd-products-items-wrap");
      [...nonAddonGpoProducts, ...nonAddonNormalProducts].forEach(item => wd_products_items_wrap.appendChild(item));
    }else{
      const is_addon_items = is_addon.querySelector(".wd-addon-items");
      [...addonGpoProducts, ...addonSubscrProducts, ...addonNormalProducts].forEach(item => is_addon_items.appendChild(item));
      is_addon_items.querySelectorAll(".wd-products")[0].classList.remove("hidden");
    }
    window.addEventListener('resize', function() {
      that.dashContentHeight();
    });
  }
  orderHistory(ret,meta_data,that) {
    let busi_order = ret.OrderHistory;
    let order_tab = document.querySelector('.wd-order-table tbody');
    if(busi_order.length > 0 && !cn(meta_data)){
      order_tab.innerHTML = '';
      for (let order=0 ; order < busi_order.length; order++){
        let curr_order = busi_order[order];
        let tracking_details = curr_order.tracking_details;
        let tb_row = document.createElement("tr");
        let odr_created_at = curr_order.order_created_at;
        if(!cn(odr_created_at)){
          odr_created_at = new Date(odr_created_at);
          odr_created_at = ((odr_created_at.getMonth() > 8) ? (odr_created_at.getMonth() + 1) : ('0' + (odr_created_at.getMonth() + 1))) + '/' + ((odr_created_at.getDate() > 9) ? odr_created_at.getDate() : ('0' + odr_created_at.getDate())) + '/' + odr_created_at.getFullYear();
        }
        let td_1 = document.createElement("td");
        td_1.textContent = odr_created_at;
        tb_row.appendChild(td_1);
        let td_2 = document.createElement("td");
        td_2.textContent = curr_order.order_number;
        tb_row.appendChild(td_2);
        let po_note = "";
        if(!cn(curr_order.customer_note)){
          if(curr_order.customer_note.includes("PO")){
            po_note = curr_order.customer_note;
          }
        }
        let td_3 = document.createElement("td");
        td_3.textContent = po_note;
        tb_row.appendChild(td_3);
        let td_4 = document.createElement("td");
        td_4.innerHTML = wetheme.formatMoney(curr_order.total_price);
        tb_row.appendChild(td_4);
        if(!cn(tracking_details)){
          if(!cn(tracking_details.tracking_url)){
            tracking_details = "<a href="+tracking_details.tracking_url+" title="+tracking_details.tracking_number+" tabindex='0' target='_blank'>"+tracking_details.tracking_number+"</a>";
          }else{
            tracking_details = tracking_details.tracking_number;
          }
        }else{
          tracking_details = "";
        }
        let order_invc = tayst.qbInvoiceDownload;
        let invoice = '<span class="wd-order-table-btn-label">Invoice '+curr_order.invoice_id+'</span>';
        order_invc = order_invc.replace("invoiceid",curr_order.invoice_id);
        if(curr_order.invoice_id == "" || curr_order.invoice_id == undefined || curr_order.invoice_id == null){
          order_invc = tayst.shopifyInvoiceDownload;
          order_invc = order_invc.replace("orderid",curr_order.order_id);
          invoice = '';
        }
        let td_5 = document.createElement("td");
        let btn_text = document.querySelector(".wd-order-table .wd-order-table-btn").getAttribute("data-title");
        btn_text = btn_text ? btn_text:"Download";
        td_5.innerHTML = '<a class="btn btn--secondary" title='+btn_text+' href='+order_invc+' tabindex="0">'+btn_text+'</a>'+invoice+'</td>';
        tb_row.appendChild(td_5);
        let td_6 = document.createElement("td");
        td_6.innerHTML = tracking_details;
        tb_row.appendChild(td_6);
        order_tab.appendChild(tb_row);
      }
    }
  }
  accountSettings(ret,meta_data){
    let FormDetails = ret.FormDetails;
    let account_settings_par = document.querySelector(".wd-account-settings");
    if(!cn(FormDetails)){
      let accounting_contact_par = account_settings_par.querySelector(".wd-settings-accounting-contact");
      let accounting_contact_name = FormDetails.billing_contact_first_name+" "+FormDetails.billing_contact_last_name+"<br/> ";
      let accounting_contact_addr1 = FormDetails.billing_address_1+", ";
      let accounting_contact_addr2 = FormDetails.billing_address_2 ? FormDetails.billing_address_2+"<br/>" : "";
      let accounting_billing_city = FormDetails.billing_city+", ";
      let accounting_billing_country = FormDetails.billing_country+"<br/>";
      let accounting_contact_phone = FormDetails.billing_phone;
      let accounting_address = accounting_contact_name + accounting_contact_addr1 + accounting_contact_addr2 +
      accounting_billing_city + accounting_billing_country + accounting_contact_phone;
      accounting_contact_par.querySelector(".wd-card-data").innerHTML = accounting_address;

      let ordering_contact_par = account_settings_par.querySelector(".wd-settings-ordering-contact");
      let ordering_contact_addr1 = FormDetails.shipping_address_1+"<br/> ";
      let ordering_contact_addr2 = FormDetails.shipping_address_2 ? FormDetails.shipping_address_2+", " : "";
      let ordering_billing_city = FormDetails.shipping_city+"<br/>";
      let ordering_billing_state = FormDetails.shipping_state ? FormDetails.shipping_state+", " : "";
      let ordering_billing_country = FormDetails.shipping_country+"<br/>";
      let ordering_contact_zip = FormDetails.shipping_zip;
      let ordering_address = ordering_contact_addr1 + ordering_contact_addr2 +
      ordering_billing_city + ordering_billing_state + ordering_billing_country + ordering_contact_zip;
      ordering_contact_par.querySelector(".wd-card-data").innerHTML = ordering_address;
    }
    let cust_addresses = ret.addresses;
    if(!cn(cust_addresses)){
      let ship_settings_par = account_settings_par.querySelector(".wd-account-settings-shippings");
      for(let addr=0;addr < cust_addresses.length; addr++){
        let currAddr = cust_addresses[addr];
        let clone_card = ship_settings_par.querySelector(".wd-card-clone .wd-card").cloneNode(true);
        let addr_name = currAddr.shipping_name;
        let addr_addr1 = currAddr.shipping_address_1+"<br/> ";
        let addr_addr2 = currAddr.shipping_address_2 ? currAddr.shipping_address_2+", " : "";
        let addr_city = currAddr.shipping_city+"<br/>";
        let addr_state = currAddr.shipping_state ? currAddr.shipping_state+", " : "";
        let addr_zip = currAddr.shipping_zip;
        let full_addr = addr_addr1 + addr_addr2 + addr_city + addr_state + addr_zip;
        clone_card.querySelector(".wd-card-data").innerHTML = full_addr;
        clone_card.querySelector(".wd-card-title").innerHTML = addr_name;
        ship_settings_par.querySelector(".wd-settings-card").appendChild(clone_card);
      }
    }
    let payment_par = account_settings_par.querySelector(".wd-account-settings-payments");
    if(FormDetails.is_credit_card == 1){
      if(!cn(ret.savedCards)){
        for(let c=0;c<ret.savedCards.length;c++){
          let curr_card = ret.savedCards[c];
          let pay_wrapper = payment_par.querySelector(".wd-settings-credit-cards-clone .wd-settings-credit-cards").cloneNode(true);
          pay_wrapper.setAttribute("data-key",curr_card.last4);
          pay_wrapper.setAttribute("data-name",curr_card.brand);
          if(curr_card.is_default == 1 || ret.savedCards.length == 1){
            pay_wrapper.querySelector("[name=wd-settings-credit-card-radio]").setAttribute("checked","checked");
          }
          pay_wrapper.querySelector(".wd-settings-credit-card-info .wd-settings-credit-card-name").textContent = curr_card.brand;
          pay_wrapper.querySelector(".wd-settings-credit-card-info .wd-settings-credit-card-digit").textContent = "****"+curr_card.last4;
          payment_par.querySelector(".wd-settings-card .wd-settings-payment-content").appendChild(pay_wrapper);
        }
        let update_paymnt_btn = payment_par.querySelector(".wd-settings-credit-cards-clone .wd-settings-credit-card-update").cloneNode(true);
        payment_par.querySelector(".wd-settings-card .wd-settings-payment-content").appendChild(update_paymnt_btn);
      }else{
        let no_payment_text = document.createElement("span");
        no_payment_text.textContent = "There are currently no active cards.";
        payment_par.querySelector(".wd-settings-card .wd-settings-payment-content").appendChild(no_payment_text);
      }
    }else{
      let pay_wrapper = payment_par.querySelector(".wd-settings-invoice-clone .wd-settings-invoice-inner").cloneNode(true);
      payment_par.querySelector(".wd-settings-card .wd-settings-payment-content").appendChild(pay_wrapper);
    }
  }
  busidashEvents(that,jsondata){
    let nav_links = '.wd-navigation .wd-nav-links li';
    document.querySelectorAll(nav_links).forEach(nav => {
      nav.addEventListener('click', (e) => {
        document.querySelectorAll(nav_links).forEach(function(n){
          n.classList.remove("active");
        });
        e.currentTarget.classList.add("active");
        e.preventDefault();
        let data_attr = e.currentTarget.attributes;
        data_attr = data_attr["data-href"];
        if(!cn(data_attr)){
          document.querySelectorAll('.wholesale-dashboard-wrap .wd-tab-items').forEach((item) => {
            const item_target = item.getAttribute("data-content");
            if (item_target == data_attr.value) {
              item.classList.add("active");
            } else {
              item.classList.remove("active");
            }
          });
          if(screen.width < 1025){
            setTimeout(function(){
              document.querySelector(".wd-navigation-close").click();
            },500);
          }
          if(data_attr.value != 2){
            document.querySelector(".wholesale-cart-icon").classList.remove("hidden");
          }else{
            document.querySelector(".wholesale-cart-icon").classList.add("hidden");
          }
          this.dashContentHeight();
        }
      });
    });
    document.addEventListener("change", (e) => {
      if (e.target.matches(".wd-qty-drop")) {
        let qty_parent = e.target.closest(".wd-product-card");
        let qty_type= e.target.tagName;
        let qty_val = e.target.value;
        if(qty_type == "INPUT" && cn(qty_val)){
          e.target.classList.remove("active");
          qty_parent.querySelector("select.wd-qty-drop").classList.add("active");
          qty_parent.querySelector("select.wd-qty-drop").value = 1;
        }
        if(qty_type == "SELECT" && qty_val == "more"){
          e.target.classList.remove("active");
          qty_parent.querySelector("input.wd-qty-drop").classList.add("active");
          qty_parent.querySelector("input.wd-qty-drop").value = 1;
        }
        qty_parent.querySelector(".wd-qty-drop.active").focus();
      }
      if(e.target.matches(".wd-subscr-delivery-date") || e.target.matches(".wd-address-drop")){
        let target_par = e.target.closest(".wd-current-subscription-copy");
        that.enableSubscriptionButton(target_par);
      }
      if(e.target.matches("input[name=wd-settings-credit-card-radio]")){
        let target_parent = e.target.closest(".wd-settings-payment-content");
        let target_button = target_parent.querySelector(".wd-settings-credit-card-update button");
        target_button.removeAttribute("disabled");
      }
    });
    document.addEventListener("click", function(e) {
      if(e.target.matches(".wd-mobile-nav-hamburger svg") || e.target.matches(".wd-mobile-nav-hamburger svg path")){
        e.preventDefault();
        document.querySelector(".wd-navigation").classList.add("active");
      }
      if(e.target.matches(".wd-navigation-close svg") || e.target.matches(".wd-navigation-close svg path")){
        e.preventDefault();
        document.querySelector(".wd-navigation").classList.remove("active");
      }
      if (e.target.matches(".wd-products-wrap .wd-products .wd-product-btn")) {
        let that1 = e.target;
        let is_addon = !cn(that1.closest(".wd-addon-items"));
        let qtyPar = that1.closest(".wd-product-card");
        let prodPar = that1.closest(".wd-products");
        let dataQty = parseInt(qtyPar.querySelector(".wd-qty-drop.active").value);
        let varId = that1.getAttribute("data-vid");
        if (dataQty > 0) {
          if(is_addon){
            that.showLoader(false,true);
            let subscr_parent_index = that1.closest(".wd-current-subscription-copy").getAttribute("data-index");
            let subscr_json = localStorage.getItem('_act_sucrpn');
            let prodId = prodPar.getAttribute("data-id");
            let varSku = that1.getAttribute("data-sku");
            let varWeight = that1.getAttribute("data-weight");
            let subsc_id = that1.closest(".wd-current-subscription-copy").getAttribute("data-subscr");
            if(!cn(subscr_json)){
              subscr_json = JSON.parse(subscr_json);
              let subscr_json_items = subscr_json.subscriptions;
              for(let i=0;i<subscr_json_items.length;i++){
                let curr_subs = subscr_json_items[i];
                if(curr_subs.subscription_id == subsc_id){
                  let subscr_items = JSON.parse(curr_subs.line_items);
                  let new_subscr_item = {'vid':varId,'quantity':dataQty};
                  subscr_items.push(new_subscr_item);
                  subscr_json.subscriptions[i].line_items = JSON.stringify(subscr_items);

                  let curr_line_items_sku = JSON.parse(curr_subs.line_items_sku);
                  let new_line_items_sku = {'sku':varSku,'quantity':dataQty,'vid':varId,'pid':prodId,'weight':varWeight};
                  curr_line_items_sku.push(new_line_items_sku);
                  subscr_json.subscriptions[i].line_items_sku = JSON.stringify(curr_line_items_sku);
                  let meta_data = localStorage.getItem("wd_meta_data");
                  if(!cn(meta_data)){
                    meta_data = JSON.parse(meta_data);
                  }
                  that.displaySubscription(subscr_json,meta_data,that);
                  break;
                }
              }
              setTimeout(function(){
                let target_par = document.querySelector(".wd-current-subscription-copy[data-index='"+subscr_parent_index+"']");
                let topPostn = target_par.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                  top: topPostn,
                  behavior: "smooth"
                });
              },200)
            }
            setTimeout(function(){
              that.hideLoader();
            },1200);
            let target_par = document.querySelector(".wd-current-subscription-copy[data-index='"+subscr_parent_index+"']");
            that.enableSubscriptionButton(target_par);
          }else{
            that1.textContent = that1.getAttribute("data-adding");
            that1.setAttribute("disabled", true);
            let cartJson = localStorage.getItem("business_cart_json");
            let itemObj = {};
            let isCartLine = false;
            if (cn(cartJson)) {
              cartJson = [];
            } else {
              cartJson = JSON.parse(cartJson);
            }
            if (!cn(cartJson)) {
              let jsonLen = cartJson.length;
              for (let c = 0; c < jsonLen; c++) {
                let currLine = cartJson[c];
                if (currLine.id == varId) {
                  isCartLine = true;
                  let totalQty = parseInt(currLine["quantity"]);
                  currLine["quantity"] = totalQty + dataQty;
                  break;
                }
              }
            }
            if (!isCartLine) {
              let finalItemTitle = prodPar.querySelector(".wd-product-title").textContent;
              let lineItemTitle = prodPar.querySelector(".wd-product-title").getAttribute("data-resttitle");
              if (!cn(lineItemTitle)) {
                let parts = lineItemTitle.split("-");
                let titleFirst = parts[0];
                let titleRest = parts.slice(1);
                if (!cn(titleFirst)) {
                  if (!titleFirst.includes("case") && !titleFirst.includes("Case")) {
                    finalItemTitle = finalItemTitle + " - " + titleFirst.trim();
                  }
                }
                if (titleRest.length) {
                  titleRest = titleRest[0];
                  if (!titleRest.includes("case") && !titleRest.includes("Case")) {
                    finalItemTitle = finalItemTitle + " - " + titleRest.trim();
                  }
                }
              }
              itemObj["id"] = varId;
              itemObj["vid"] = varId;
              itemObj["quantity"] = dataQty;
              itemObj["price"] = that1.getAttribute("data-price");
              itemObj["sku"] = that1.getAttribute("data-sku");
              itemObj["weight"] = that1.getAttribute("data-weight");
              itemObj["case"] = that1.getAttribute("data-case");
              itemObj["image"] = qtyPar.querySelector(".wd-product-image").getAttribute("src");
              itemObj["title"] = qtyPar.querySelector(".wd-product-variant-name").getAttribute("data-vname");
              itemObj["product_title"] = finalItemTitle;
              cartJson.push(itemObj);
            }
            window.wholesaleSideCart.reInit(cartJson, true);
            setTimeout(function() {
              that1.textContent = that1.getAttribute("data-text");
              that1.removeAttribute("disabled");
            }, 2000);
          }
        } else {
          that1.textContent = that1.getAttribute("data-select");
          setTimeout(function() {
            that1.textContent = that1.getAttribute("data-text");
          }, 2000);
        }
      }
      if (e.target.matches(".wd-product-variant-learn-more-link")) {
        e.preventDefault();
        let dataVal = e.target.getAttribute("data-href");
        let modal_cont = document.querySelector(`.wd-product-variant-learn-more-wrap[data-id="${dataVal}"]`).outerHTML;
        that.showThemeModal(modal_cont);
      }
      if (e.target.matches(".wd-delivery-text-wrap .wd-summary-toggle-btn")) {
        e.stopPropagation();
        let target_par = e.target.closest(".wd-current-subscription-copy");
        if(e.target.classList.contains('active')){
          e.target.classList.remove("active");
          e.target.textContent = e.target.getAttribute("data-show");
        }else{
          e.target.classList.add("active");
          e.target.textContent = e.target.getAttribute("data-hide");
          setTimeout(function(){
            let topPostn = (target_par.querySelector(".wd-subscription-summary").getBoundingClientRect().top - 50) + window.pageYOffset;
            window.scrollTo({
              top: topPostn,
              behavior: "smooth"
            });
          })
        }
        target_par.querySelector(".wd-subscription-summary").classList.toggle("hidden");
      }
      if (e.target.matches(".wd-addon-show-toggle")) {
        e.stopPropagation();
        let toggle_click = e.target;
        let toggle_parent = toggle_click.closest(".wd-products-wrap");
        if(toggle_click.classList.contains("active")){
          toggle_parent.querySelectorAll(".wd-products").forEach(function(card,i){
            if(i!= 0){
              card.classList.add("hidden");
            }
          });
          toggle_click.classList.remove("active");
          toggle_click.textContent = toggle_click.getAttribute("data-more");
          let topPos = toggle_parent.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: topPos,
            behavior: "smooth"
          });
        }else{
          toggle_parent.querySelectorAll(".wd-products").forEach(function(card,i){
            card.classList.remove("hidden");
          });
          toggle_click.classList.add("active");
          toggle_click.textContent = toggle_click.getAttribute("data-less");
        }
        setTimeout(function(){
          that.dashContentHeight();
        },100);
      }
      if(e.target.matches(".wd-current-subscription-no-subscr .btn")){
        e.preventDefault();
        document.querySelector(".wd-navigation .wd-menu li:first-child").click();
      }
      if(e.target.matches(".wd-subscr-frequency-edit")){
        e.preventDefault();
        if(jsondata?.FormDetails?.status == 2){
          return;
        }
        let freq_parent = e.target.closest(".wd-current-subscription-copy");
        let freq_parent_index = freq_parent.getAttribute("data-index");
        let curr_freq = freq_parent.querySelector(".wd-subscr-frequency-number").textContent;
        let popup_par = document.querySelector(`.subscrIndex_${freq_parent_index} .wd-subscr-frequency-popup`).outerHTML;
        let temp_div = document.createElement("div");
        temp_div.innerHTML = popup_par;
        let popup_data = temp_div.firstElementChild;
        popup_data.querySelector(".wd-subscr-freq-edit-select").value = curr_freq;
        popup_data.querySelector(".wd-subscr-frequency-popup-item").setAttribute("data-position",freq_parent_index);
        that.showThemeModal(popup_data.outerHTML);
      }
      if(e.target.matches(".wd-subscr-freq-edit-btn")){
        e.preventDefault();
        let freq_pop_par = e.target.closest(".wd-subscr-frequency-popup-item");
        let edit_parent_index = freq_pop_par.getAttribute("data-position");
        let freq_select = freq_pop_par.querySelector(".wd-subscr-freq-edit-select");
        let freq_val = freq_select.value;
        let freq_type = freq_select.options[freq_select.selectedIndex].getAttribute("data-type");
        if(freq_type != "weeks" && freq_type != "months" && freq_type != "year"){
          freq_type = "weeks";
        }
        let target_subscr = '.wd-current-subscription .wd-current-subscription-copy[data-index="'+edit_parent_index+'"]';
        target_subscr = document.querySelector(target_subscr);
        target_subscr.querySelector(".wd-subscr-frequency-number").textContent = freq_val;
        target_subscr.querySelector(".wd-subscr-frequency-type").textContent = freq_type;
        that.hideThemeModal();
        that.enableSubscriptionButton(target_subscr);
      }
      if(e.target.matches(".wd-settings-credit-card-update button")){
        let subscr_json = localStorage.getItem('_act_sucrpn');
        if (!cn(subscr_json)) {
          let card_last4 = '';
          let card_company = '';
          let exp_month = '';
          let exp_year = '';
          subscr_json = JSON.parse(subscr_json);
          let saved_cards = subscr_json.savedCards;
          let btn_parent = e.target.closest(".wd-settings-payment-content");
          let curr_radio = btn_parent.querySelectorAll("input[name='wd-settings-credit-card-radio']:checked");
          if (curr_radio.length) {
            that.showLoader();
            let card = curr_radio[0].closest(".wd-settings-credit-cards");
            card_last4 = card.getAttribute("data-key");
            card_company = card.getAttribute("data-name");
            for (let i = 0; i < saved_cards.length; i++) {
              const curr_card = saved_cards[i];
              if (curr_card.last4 === card_last4 && curr_card.brand === card_company) {
                exp_month = curr_card.exp_month;
                exp_year = curr_card.exp_year;
                break;
              }
            }
            let formdata = new FormData();
            formdata.append("brand", card_company);
            formdata.append("exp_month", exp_month);
            formdata.append("exp_year", exp_year);
            formdata.append("last4", card_last4);
            formdata.append("form_id", subscr_json.FormDetails.form_id);
            fetch(tayst.updateDefaultCard, { method: "POST", body: formdata })
            .then(r => r.text())
            .then(res => {
              if (res != '') {
                res = JSON.parse(res);
                if (res.status == 0) { localStorage.setItem("hide_success_popup", 1); location.reload(); }
                else { alert(res.message); that.hideLoader(); }
              }
            })
            .catch(err => { alert(JSON.parse(err).message); that.hideLoader(); });
          }
        }
      }
      if (e.target.matches(".wd-account-settings .wd-card-edit")) {
        e.preventDefault();
        let modal_cont = document.querySelector("#wholesale-dashboard .wd-account-settings-edit-popup").outerHTML;
        that.showThemeModal(modal_cont);
      }
      if(e.target.matches(".wd-subscr-active-pause-btn")){
        e.preventDefault();
        if(jsondata?.FormDetails?.status == 2){
          return;
        }
        let curr_status = e.target.getAttribute("data-status");
        let freq_parent = e.target.closest(".wd-current-subscription-copy");
        let freq_parent_subscr = freq_parent.getAttribute("data-subscr");
        if(curr_status == 0){
          let modal_cont = document.querySelector("#wholesale-dashboard .wd-pause-subscr-popup").outerHTML;
          const themeModal = document.querySelector('theme-modal');
          const themeModalContent = themeModal.querySelector('template[data-theme-modal-content]');
          const modal_fragment = themeModalContent.content; // DocumentFragment
          modal_fragment.querySelector('.modal-content').innerHTML = modal_cont;
          modal_fragment.querySelector('.modal-content').setAttribute("data-sbrn",freq_parent_subscr);
          document.querySelector(".page-popup-trigger").click();
        }else{
          that.changeSubscriptionStatus(that,freq_parent_subscr,0);
        }
      }
      if(e.target.matches(".wd-pause-subscr-confirm")){
        e.preventDefault();
        let close_par = e.target.closest(".modal-content");
        let subscr_id = close_par.getAttribute("data-sbrn");
        let pause_reason = close_par.querySelector(".wd-pause-subscr-reasons").value;
        that.changeSubscriptionStatus(that,subscr_id,1,pause_reason);
      }
      if(e.target.matches(".wd-subscr-deliver-now-confirm")){
        that.showLoader(true);
        let pop_parent_subscr = e.target.closest(".modal-content").getAttribute("data-sbrn");
        let data = new URLSearchParams();
        let close_btn = e.target.closest(".theme-modal-content").querySelector("button[data-close]");
        data.append("subscription_id", pop_parent_subscr);
        fetch(tayst.subscriptionShipNow, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: data
        })
        .then(response => response.text())
        .then(data => {
          if(data != ''){
            data = JSON.parse(data);
            close_btn.click();
            if(data.status == 0){
              localStorage.setItem("hide_success_popup",1);
              location.reload();
            }else{
              alert(data.message);
            }
            setTimeout(function(){
              that.hideLoader();
            },1000);
          }
        })
        .catch(error => {
          if(error != ''){
            error = JSON.parse(error);
          }
          alert(error.message);
          that.hideLoader();
        });
      }
      if(e.target.matches(".wd-delivery-now")){
        if(jsondata?.FormDetails?.status == 2){
          return;
        }
        let freq_parent = e.target.closest(".wd-current-subscription-copy");
        let freq_parent_subscr = freq_parent.getAttribute("data-subscr");
        let modal_cont = document.querySelector("#wholesale-dashboard .wd-delivery-now-popup").outerHTML;
        const themeModal = document.querySelector('theme-modal');
        const themeModalContent = themeModal.querySelector('template[data-theme-modal-content]');
        const modal_fragment = themeModalContent.content; // DocumentFragment
        modal_fragment.querySelector('.modal-content').innerHTML = modal_cont;
        modal_fragment.querySelector('.modal-content').setAttribute("data-sbrn",freq_parent_subscr);
        document.querySelector(".page-popup-trigger").click();
      }
      if(e.target.matches(".wd-current-subscription-copy .wd-update-plan")){
        if(jsondata?.FormDetails?.status == 2){
          return;
        }
        let close_par = e.target.closest(".wd-current-subscription-copy");
        let subscription_id = close_par.getAttribute("data-subscr");
        let data_json = localStorage.getItem('_act_sucrpn');
        let line_items = '';
        let form_id = '';
        if(!cn(data_json)){
          that.showLoader(false,true);
          data_json = JSON.parse(data_json);
          let curr_subscriptions = data_json.subscriptions;
          if(!cn(curr_subscriptions)){
            for(let s=0;s<curr_subscriptions.length;s++){
              let loop_sbcrn = curr_subscriptions[s];
              if(loop_sbcrn.subscription_id == subscription_id){
                line_items = loop_sbcrn.line_items;
                form_id = loop_sbcrn.form_id;
                break;
              }
            }
          }
          if(!cn(line_items) != 0 && !cn(form_id)){
            let address_id = close_par.querySelector(".wd-address-drop").value;
            let next_order_date = close_par.querySelector(".wd-subscr-delivery-date").value;
            let call_date = that.formatToLocalISO(next_order_date);
            let order_freq = close_par.querySelector(".wd-subscr-frequency-number").textContent;
            let order_freq_val = close_par.querySelector(".wd-subscr-frequency-type").textContent;
            let data_obj = {
              subscription_id: subscription_id,
              address_id: address_id,
              next_order_date: call_date,
              order_freq: order_freq,
              order_freq_val: order_freq_val,
              line_items: line_items,
              form_id: form_id
            };
            let data = new URLSearchParams();
            data.append("data", JSON.stringify(data_obj));
            fetch(tayst.updateSubscription, {
              method: "POST",
              body: data
            })
            .then(response => response.text())
            .then(data => {
              if(data != ''){
                data = JSON.parse(data);
                if(data.status == 0){
                  e.target.classList.add("hidden");
                  close_par.querySelector(".wd-update-plan-text").classList.add("hidden");
                  localStorage.setItem("hide_success_popup",1);
                  that.showSuccessPopup(that);
                }else{
                  alert(data.message);
                }
                setTimeout(function(){
                  that.hideLoader();
                },1000);
              }
            })
            .catch(error => {
              if(error != ''){
                error = JSON.parse(error);
              }
              alert(error.message);
              that.hideLoader();
            });
          }
        }
      }
      if (e.target.matches(".wd-purchased-item .wd-purchased-item-qty-spin")) {
        e.preventDefault();
        let spinBtn = e.target.closest(".wd-purchased-item-qty-spin");
        let item = spinBtn.closest(".wd-purchased-item");
        let subscr_json = localStorage.getItem('_act_sucrpn');
        let subscr_parent_id = e.target.closest(".wd-current-subscription-copy").getAttribute("data-subscr");
        let subscr_parent_index = e.target.closest(".wd-current-subscription-copy").getAttribute("data-index");
        let item_vid = item.getAttribute("data-vid");
        const qtyInput = item.querySelector(".wd-purchased-item-qty");
        let qty = parseInt(qtyInput.value);
        if (spinBtn.classList.contains("wd-purchased-item-qty-plus")) {
          qty += 1;
          qtyInput.value = qty;
        }else if(spinBtn.classList.contains("wd-purchased-item-remove")){
          qty = 0;
        } else {
          qty -= 1;
          if (qty > 0) {
            qtyInput.value = qty;
          }else{
            qty = 1;
            return;
          }
        }
        that.showLoader(false,true);
        if(!cn(subscr_json)){
          subscr_json = JSON.parse(subscr_json);
          let subscr_json_items = subscr_json.subscriptions;
          for(let i=0;i<subscr_json_items.length;i++){
            let curr_subs = subscr_json_items[i];
            if(curr_subs.subscription_id == subscr_parent_id){
              let subscr_items = JSON.parse(curr_subs.line_items);
              let subscr_items_sku = JSON.parse(curr_subs.line_items_sku);
              for(let itm=0;itm<subscr_items.length;itm++){
                let curr_itm = subscr_items[itm];
                if(curr_itm.vid == item_vid){
                  if(qty != 0){
                    subscr_items[itm].quantity = qty;
                    subscr_json.subscriptions[i].line_items = JSON.stringify(subscr_items);
                  }else{
                    subscr_items.splice(itm,1);
                    subscr_json.subscriptions[i].line_items = JSON.stringify(subscr_items);
                  }
                  break;
                }
              }
              for(let itmsku=0;itmsku<subscr_items_sku.length;itmsku++){
                let curr_itm = subscr_items_sku[itmsku];
                if(curr_itm.vid == item_vid){
                  if(qty != 0){
                    subscr_items_sku[itmsku].quantity = qty;
                    subscr_json.subscriptions[i].line_items_sku = JSON.stringify(subscr_items_sku);
                  }else{
                    subscr_items_sku.splice(itmsku,1);
                    subscr_json.subscriptions[i].line_items_sku = JSON.stringify(subscr_items_sku);
                  }
                  break;
                }
              }
            }
            let meta_data = localStorage.getItem("wd_meta_data");
            if(!cn(meta_data)){
              meta_data = JSON.parse(meta_data);
            }
            that.displaySubscription(subscr_json,meta_data,that);
            let par_target = document.querySelector(".wd-current-subscription-copy[data-index='"+subscr_parent_index+"']");
            that.enableSubscriptionButton(par_target);
          }
        }
        setTimeout(function(){
          that.hideLoader();
        },1200);
      }
      if(e.target.matches(".wd-product-backorder-text.has-backorder")){
        e.preventDefault();
        let pop_data = e.target.querySelector(".hide");
        const themeModal = document.querySelector('theme-modal');
        const themeModalContent = themeModal.querySelector('template[data-theme-modal-content]');
        const modal_fragment = themeModalContent.content; // DocumentFragment
        modal_fragment.querySelector('.modal-content').innerHTML = pop_data.innerHTML;
        document.querySelector(".page-popup-trigger").click();
      }
      if(e.target.matches(".wholesale-logout")){
        e.preventDefault();
        localStorage.removeItem("buss_user");
        localStorage.removeItem("_act_sucrpn");
        localStorage.removeItem("wd_meta_data");
        const loginUrl = document.querySelector(".wholesale-dashboard-wrap").getAttribute("data-login");
        window.location.href = loginUrl;
      }
    });
    window.addEventListener('resize', function() {
      that.dashContentHeight();
    });
  }
  changeSubscriptionStatus(that,subscr_id,status,pause_reason=""){
    that.showLoader();
    let formdata = new FormData();
    formdata.append("subscription_id", subscr_id);
    formdata.append("pause_reason", pause_reason);
    formdata.append("status", status);
    let subscr_json = localStorage.getItem('_act_sucrpn');
    if(!cn(subscr_json)){
      subscr_json = JSON.parse(subscr_json);
      formdata.append("form_id", subscr_json.FormDetails.form_id);
    }
    fetch(tayst.pauseActiveSubscription, {
      method: "POST",
      body: formdata
    })
    .then(response => response.text())
    .then(data => {
      if(data != ''){
        data = JSON.parse(data);
        if(data.status == 0){
          localStorage.setItem("hide_success_popup",1);
          location.reload();
        }else{
          that.hideLoader();
        }
      }
    })
    .catch(error => {
      if(error != ''){
        error = JSON.parse(error);
      }
      alert(error.message);
      that.hideLoader();
    });
  }
  dashContentHeight = function() {
    document.querySelectorAll(".wd-products-wrap .wd-products-items-wrap .wd-products").forEach(wrap => {
      const itemTitle = wrap.querySelectorAll(".wd-product-variant-name-parent");
      const itemTitleChild = wrap.querySelectorAll(".wd-product-variant-name-parent .wd-product-variant-name");
      const itemCompare = wrap.querySelectorAll(".wd-product-price-compare-parent");
      const itemCompareChild = wrap.querySelectorAll(".wd-product-price-compare-parent .wd-product-price-compare");
      itemTitle.forEach(item => {
        item.style.height = "unset";
      });
      itemCompare.forEach(compare => {
        compare.style.height = "unset";
      });
      if (window.innerWidth > 359) {
        window.miniHeight(itemTitle, itemTitleChild);
        window.miniHeight(itemCompare, itemCompareChild);
      }
    });
  }
  enableSubscriptionButton(parent){
    parent.querySelector(".wd-update-plan").classList.remove("hidden");
    parent.querySelector(".wd-update-plan-text").classList.remove("hidden");
    let itemPostn = (parent.querySelector(".wd-update-plan").getBoundingClientRect().top - 50) + window.pageYOffset;
    window.scrollTo({
      top: itemPostn,
      behavior: "smooth"
    });
  }
  sideCartData(ret) {
    // Add condition "ret.FormDetails.is_credit_card == 1" to redirect only credit card checkouts.
    let wholesaleSideCart = document.getElementById("wholesale-side-cart");
    let sidecartBtn = wholesaleSideCart.querySelector(".sidecart-button");
    if (true) {
      sidecartBtn.setAttribute("data-attr", 1);   // ret.FormDetails.is_credit_card
      sidecartBtn.textContent = sidecartBtn.getAttribute("data-review");
      let footerMsg = wholesaleSideCart.querySelector(".sidecart-footer-msg");
      footerMsg.classList.add("hidden");
    }
    if(!cn(ret.addresses)){
      let busi_form_dtl = ret.FormDetails;
      for(let addr=0;addr < ret.addresses.length; addr++){
        let curr_addr = ret.addresses[addr];
        let selected_addr = "select";
        let ship_company_name = "";
        let ship_address_2 = "";
        if(!cn(curr_addr.shipping_name)){
          ship_company_name = curr_addr.shipping_name+" | ";
        }
        if(!cn(curr_addr.shipping_address_2)){
          ship_address_2 = curr_addr.shipping_address_2+", ";
        }
        let curr_addr_addr = curr_addr.shipping_address_1+", "+ship_address_2+curr_addr.shipping_city+", "+curr_addr.shipping_state+" "+curr_addr.shipping_zip;
        let busi_form_dtl_shipping_address_2 = busi_form_dtl.shipping_address_2;
        if(!cn(busi_form_dtl_shipping_address_2)){
          busi_form_dtl_shipping_address_2 = busi_form_dtl.shipping_address_2+", "
        }
        let selected_ship_addr = busi_form_dtl.shipping_address_1+", "+busi_form_dtl_shipping_address_2+busi_form_dtl.shipping_city+", "+busi_form_dtl.shipping_state+" "+busi_form_dtl.shipping_zip;
        if(selected_ship_addr === curr_addr_addr){
          selected_addr = "selected";
          document.querySelector(".sidecart-ship-addr-wrap .sidecart-ship-addr").setAttribute("data-val",curr_addr.id);
        }
        let ship_option = document.createElement('option');
        ship_option.innerHTML = ship_company_name+curr_addr_addr;
        ship_option.value = curr_addr.id;
        ship_option.setAttribute(selected_addr,selected_addr); 
        document.querySelector(".sidecart-ship-addr-wrap .sidecart-ship-addr").appendChild(ship_option);
      }
    }
    if(ret.FormDetails?.status == 2){
      sidecartBtn.classList.add("hide");
    }
  }
  showLoader(show_text=true,bg_blur=false){
    document.querySelector("#page-loader").classList.add('active');
    if(!show_text){
      document.querySelector("#page-loader").classList.add('hide-text');
    }
    if(bg_blur){
      document.querySelector("#page-loader").classList.add('bg-blur');
    }
  }
  hideLoader(){
    document.querySelector("#page-loader").classList.remove('active', 'hide-text', 'bg-blur');
  }
  hideThemeModal(){
    const themeModal = document.querySelector('theme-modal');
    themeModal.hideModal();
  }
  showThemeModal(data){
    const themeModal = document.querySelector('theme-modal');
    const themeModalContent = themeModal.querySelector('template[data-theme-modal-content]');
    const modal_fragment = themeModalContent.content; // DocumentFragment
    modal_fragment.querySelector('.modal-content').innerHTML = data;
    document.querySelector(".page-popup-trigger").click();
  }
  formatToLocalISO(dateString) {
    let date_numbers = dateString.split('/').map(Number);
    let month = date_numbers[0];
    let day = date_numbers[1];
    let year = date_numbers[2];
    if(!dateString.includes("/")){
      date_numbers = dateString.split('-').map(Number);
      year = date_numbers[0];
      month = date_numbers[1];
      day = date_numbers[2];
    }
    const localDate = new Date(year, month - 1, day);
    const yyyy = localDate.getFullYear();
    const mm = String(localDate.getMonth() + 1).padStart(2, '0');
    const dd = String(localDate.getDate()).padStart(2, '0');
    if(!dateString.includes("/")){
      return `${mm}-${dd}-${yyyy}`;
    }else{
      return `${yyyy}-${mm}-${dd}`;
    }
  }
  showSuccessPopup(that){
    let hide_success_popup = localStorage.getItem("hide_success_popup");
    if(!cn(hide_success_popup)){
      let modal_cont = document.querySelector("#wholesale-dashboard .wd-subscription-success-popup").outerHTML;
      that.showThemeModal(modal_cont);
    }
    localStorage.removeItem("hide_success_popup");
  }
}
const dashboard = new Dashboard();
dashboard.registerWholesaleInit();